import { render, staticRenderFns } from "./docUpload_button_component.vue?vue&type=template&id=2ef6055a&"
import script from "./docUpload_button_component.vue?vue&type=script&lang=js&"
export * from "./docUpload_button_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports